// assets
import {
    IconBasket,
    IconBuildingCommunity,
    IconCalendar,
    IconClipboardCheck,
    IconCoin,
    IconFileCertificate,
    IconLayoutKanban,
    IconMail,
    IconMessages,
    IconNfc,
    IconSchool,
    IconUserCheck,
    IconUsers,
    IconWallet,
    IconIndentIncrease,
    IconCalendarTime,
    IconNotebook,
    IconFileText,
    IconBrandCodesandbox,
    IconClipboardList,
    IconVirus,
    IconDeviceAnalytics,
    IconChartBubble
} from '@tabler/icons';

// constant
const icons = {
    IconUserCheck,
    IconBasket,
    IconMessages,
    IconLayoutKanban,
    IconMail,
    IconCalendar,
    IconNfc,
    IconSchool,
    IconBuildingCommunity,
    IconUsers,
    IconClipboardCheck,
    IconFileCertificate,
    IconWallet,
    IconCoin,
    IconIndentIncrease,
    IconCalendarTime,
    IconNotebook,
    IconFileText,
    IconBrandCodesandbox,
    IconClipboardList,
    IconVirus,
    IconDeviceAnalytics,
    IconChartBubble
};

export const MENU_ICONS: Record<string, any> = {
    IconUserCheck: icons.IconUserCheck,
    IconBasket: icons.IconBasket,
    IconMessages: icons.IconMessages,
    IconLayoutKanban: icons.IconLayoutKanban,
    IconMail: icons.IconMail,
    IconCalendar: icons.IconCalendar,
    IconNfc: icons.IconNfc,
    IconSchool: icons.IconSchool,
    IconBuildingCommunity: icons.IconBuildingCommunity,
    IconUsers: icons.IconUsers,
    IconClipboardCheck: icons.IconClipboardCheck,
    IconFileCertificate: icons.IconFileCertificate,
    IconWallet: icons.IconWallet,
    IconCoin: icons.IconCoin,
    IconIndentIncrease: icons.IconIndentIncrease,
    IconCalendarTime: icons.IconCalendarTime,
    IconNotebook: icons.IconNotebook,
    IconFileText: icons.IconFileText,
    IconBrandCodesandbox: icons.IconBrandCodesandbox,
    IconClipboardList: icons.IconClipboardList,
    IconVirus: icons.IconVirus,
    IconDeviceAnalytics: icons.IconDeviceAnalytics,
    IconChartBubble: icons.IconChartBubble
};
